// extracted by mini-css-extract-plugin
module.exports = {"list":"ModalCoursesList_list__Z_baU","button":"ModalCoursesList_button__C989E","item":"ModalCoursesList_item__Ndkpx"};